/**
 * SF-T-266: a live run's turn report, as its engine posts it ("R-7's agent finished turn 2 (live, completed)."):
 * a notification or Inbox item about one opens the agent's chat (the task with ?agent=chat) rather than the task.
 * Its questions ("has questions (live, …)") don't: they're answered in the task's Comments.
 */
export const isLiveTurnReport = (text: string | null | undefined): boolean => !!text && /\bagent finished turn \d+ \(live, /.test(text);

/** The search a link adds to open a task's agent chat. */
export const AGENT_CHAT_SEARCH = '?agent=chat';
